export const REQUEST_UPLOAD_URL =
  "https://8ofs62v7n7.execute-api.eu-north-1.amazonaws.com/dev/requestUploadUrl";
export const FINAL_SOUNDS_BUCKET =
  "https://s3.eu-north-1.amazonaws.com/robot-choir-sound-final";

export const SOUND_EVENT_NAME = "riDays";

export const MAX_SOUND_DURATION = 10;

export const CIRCLE_RADIUS = 0.5;
export const ACTION_BUTTON_RADIUS = [0.5, 0.5]; // Inner, outer
export const PROGRESS_INDICATOR_RADIUS = 0.35;

export const ANALYSER_NUM_SPECTRAL_FREQUENCIES = 128;
export const ANALYSER_SMOOTHING = 0.8;

export const SOUND_REVERSAL_PROBABILITY = 0.33;
export const SOUND_FREEZE_PROBABILITY = 0.77;

export const INDICATOR_SHRINK_DURATION = 1500;
export const SHRINK_TRAVEL_DELAY = 0;
export const CENTER_TRAVEL_DURATION = 1500;
